export type Year = (typeof years)[number];

export const years = [
  1990, 1995, 2000, 2005, 2010, 2015, 2020, 2025, 2030, 2035, 2040, 2045, 2050, 2055, 2060, 2065, 2070, 2075, 2080,
  2085, 2090, 2095, 2100,
] as const;

export const DEFAULT_YEAR: Year = 2055;
export const MAX_YEAR: Year = 2100;

export const CURRENT_YEAR = new Date().getFullYear();
const currentYearModule = CURRENT_YEAR % 5;
export const currentYearOptions = [CURRENT_YEAR - currentYearModule, CURRENT_YEAR - currentYearModule + 5];
